var _g, _path, _path2, _path3, _g2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1640_38215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5151 7.16616C28.8887 7.48842 29.0754 7.91138 29.0754 8.43505C29.0754 8.89829 28.926 9.30111 28.6272 9.6435C28.347 9.9859 27.9828 10.1772 27.5345 10.2175C27.4784 10.2175 27.4318 10.2175 27.3944 10.2175C27.0022 10.2175 26.6473 10.0967 26.3297 9.85498C25.5826 9.35146 24.7701 9.0997 23.8922 9.0997C23.0517 9.0997 22.398 9.32125 21.931 9.76435C21.4828 10.1873 21.2586 10.8218 21.2586 11.6677C21.2586 12.1309 21.38 12.5539 21.6228 12.9366C21.8843 13.3192 22.2205 13.6516 22.6315 13.9335C23.0424 14.1954 23.5093 14.4773 24.0323 14.7795C24.5553 15.0614 25.0876 15.3434 25.6293 15.6254C26.171 15.8872 26.7033 16.2195 27.2263 16.6224C27.7493 17.005 28.2162 17.428 28.6272 17.8912C29.0381 18.3343 29.3649 18.8983 29.6078 19.5831C29.8693 20.2679 30 21.0232 30 21.8489C30 23.5206 29.5797 24.9406 28.7392 26.1088C27.8987 27.2568 26.7033 28.0121 25.153 28.3746C25.0036 28.3948 24.9289 28.4854 24.9289 28.6465V30.4592C24.9289 30.8822 24.7888 31.2447 24.5086 31.5468C24.2471 31.8489 23.9203 32 23.528 32C23.1358 32 22.7996 31.8489 22.5194 31.5468C22.2392 31.2447 22.0991 30.8822 22.0991 30.4592V28.7674C22.0991 28.6062 22.0338 28.5156 21.903 28.4955C20.4088 28.2739 19.0172 27.7402 17.7284 26.8943C17.3362 26.6324 17.1027 26.2497 17.028 25.7462C17.0093 25.6455 17 25.5347 17 25.4139C17 25.0312 17.1121 24.6788 17.3362 24.3565L17.3642 24.2659C17.607 23.8832 17.9526 23.6415 18.4009 23.5408C18.5129 23.5206 18.625 23.5106 18.7371 23.5106C19.0546 23.5106 19.3534 23.6012 19.6336 23.7825C20.7917 24.5277 21.9217 24.9003 23.0237 24.9003C24.9662 24.9003 25.9375 23.9839 25.9375 22.1511C25.9375 21.6677 25.8068 21.2145 25.5453 20.7915C25.3024 20.3686 24.9756 20.006 24.5647 19.7039C24.1724 19.4018 23.7148 19.0997 23.1918 18.7976C22.6688 18.4753 22.1272 18.1732 21.5668 17.8912C21.0251 17.6093 20.4928 17.2769 19.9698 16.8943C19.4468 16.4914 18.9799 16.0786 18.569 15.6556C18.1767 15.2125 17.8499 14.6687 17.5884 14.0242C17.3455 13.3797 17.2241 12.6647 17.2241 11.8792C17.2241 10.2477 17.6351 8.88822 18.4569 7.8006C19.2974 6.69285 20.4461 5.96777 21.903 5.62538C22.0338 5.58509 22.0991 5.49446 22.0991 5.35347V3.51057C22.0991 3.08761 22.2392 2.73515 22.5194 2.45317C22.7996 2.15106 23.1358 2 23.528 2C23.9203 2 24.2471 2.15106 24.5086 2.45317C24.7888 2.73515 24.9289 3.08761 24.9289 3.51057V5.29305C24.9289 5.43404 25.0036 5.52467 25.153 5.56495C26.3671 5.7865 27.4878 6.32024 28.5151 7.16616Z",
    fill: "url(#paint0_linear_1640_38215)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5357 26.9546C40.7645 25.9023 39.3032 25.6871 38.2718 26.4736L27.6754 34.119C27.3649 34.343 26.9955 34.4665 26.6152 34.4736L20.2042 34.5912C16.8208 34.4248 17.5165 30.5672 19.833 30.6189L26.5271 30.6336C27.7491 30.5947 28.709 29.5531 28.6711 28.3065C28.6332 27.06 27.6118 26.0808 26.3898 26.1196L13.9416 26.0924C13.3589 26.1108 12.8229 26.3394 12.4391 26.7275L12.4193 26.6705L5.15353 32.2103L5.09068 32.1187C4.76637 31.6463 4.12192 31.5304 3.65874 31.8612L0.437415 34.1616C-0.0259145 34.4924 -0.139386 35.1497 0.184929 35.6222L7.00283 45.5537C7.32714 46.0261 7.97159 46.142 8.43477 45.8112L11.6561 43.5107C12.0346 43.2404 12.1793 42.7523 12.0428 42.325C12.875 41.8676 14.1512 41.1909 14.8562 41.1808C14.8562 41.1808 26.4998 41.033 26.6207 41.0255C27.2406 41.0582 27.8748 40.8787 28.4107 40.4701L41.0641 30.2833C42.0958 29.4969 42.3068 28.0063 41.5358 26.9542L41.5357 26.9546Z",
    fill: "url(#paint1_linear_1640_38215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57626 36.5021C4.29067 36.5021 4.86981 35.9113 4.86981 35.1827C4.86981 34.454 4.29067 33.8633 3.57626 33.8633C2.86186 33.8633 2.28271 34.454 2.28271 35.1827C2.28271 35.9113 2.86186 36.5021 3.57626 36.5021Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 42,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5357 26.9546C40.7645 25.9023 39.3032 25.6871 38.2718 26.4736L27.6754 34.119C27.3649 34.343 26.9955 34.4665 26.6152 34.4736L20.2042 34.5912C16.8208 34.4248 17.5165 30.5672 19.833 30.6189L26.5271 30.6336C27.7491 30.5947 28.709 29.5531 28.6711 28.3065C28.6332 27.06 27.6118 26.0808 26.3898 26.1196L13.9416 26.0924C13.3589 26.1108 12.8229 26.3394 12.4391 26.7275L12.4193 26.6705L5.15353 32.2103L5.09068 32.1187C4.76637 31.6463 4.12192 31.5304 3.65874 31.8612L0.437415 34.1616C-0.0259145 34.4924 -0.139386 35.1497 0.184929 35.6222L7.00283 45.5537C7.32714 46.0261 7.97159 46.142 8.43477 45.8112L11.6561 43.5107C12.0346 43.2404 12.1793 42.7523 12.0428 42.325C12.875 41.8676 14.1512 41.1909 14.8562 41.1808C14.8562 41.1808 26.4998 41.033 26.6207 41.0255C27.2406 41.0582 27.8748 40.8787 28.4107 40.4701L41.0641 30.2833C42.0958 29.4969 42.3068 28.0063 41.5358 26.9542L41.5357 26.9546Z",
    fill: "url(#paint2_linear_1640_38215)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38215)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1640_38215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5151 7.16616C28.8887 7.48842 29.0754 7.91138 29.0754 8.43505C29.0754 8.89829 28.926 9.30111 28.6272 9.6435C28.347 9.9859 27.9828 10.1772 27.5345 10.2175C27.4784 10.2175 27.4318 10.2175 27.3944 10.2175C27.0022 10.2175 26.6473 10.0967 26.3297 9.85498C25.5826 9.35146 24.7701 9.0997 23.8922 9.0997C23.0517 9.0997 22.398 9.32125 21.931 9.76435C21.4828 10.1873 21.2586 10.8218 21.2586 11.6677C21.2586 12.1309 21.38 12.5539 21.6228 12.9366C21.8843 13.3192 22.2205 13.6516 22.6315 13.9335C23.0424 14.1954 23.5093 14.4773 24.0323 14.7795C24.5553 15.0614 25.0876 15.3434 25.6293 15.6254C26.171 15.8872 26.7033 16.2195 27.2263 16.6224C27.7493 17.005 28.2162 17.428 28.6272 17.8912C29.0381 18.3343 29.3649 18.8983 29.6078 19.5831C29.8693 20.2679 30 21.0232 30 21.8489C30 23.5206 29.5797 24.9406 28.7392 26.1088C27.8987 27.2568 26.7033 28.0121 25.153 28.3746C25.0036 28.3948 24.9289 28.4854 24.9289 28.6465V30.4592C24.9289 30.8822 24.7888 31.2447 24.5086 31.5468C24.2471 31.8489 23.9203 32 23.528 32C23.1358 32 22.7996 31.8489 22.5194 31.5468C22.2392 31.2447 22.0991 30.8822 22.0991 30.4592V28.7674C22.0991 28.6062 22.0338 28.5156 21.903 28.4955C20.4088 28.2739 19.0172 27.7402 17.7284 26.8943C17.3362 26.6324 17.1027 26.2497 17.028 25.7462C17.0093 25.6455 17 25.5347 17 25.4139C17 25.0312 17.1121 24.6788 17.3362 24.3565L17.3642 24.2659C17.607 23.8832 17.9526 23.6415 18.4009 23.5408C18.5129 23.5206 18.625 23.5106 18.7371 23.5106C19.0546 23.5106 19.3534 23.6012 19.6336 23.7825C20.7917 24.5277 21.9217 24.9003 23.0237 24.9003C24.9662 24.9003 25.9375 23.9839 25.9375 22.1511C25.9375 21.6677 25.8068 21.2145 25.5453 20.7915C25.3024 20.3686 24.9756 20.006 24.5647 19.7039C24.1724 19.4018 23.7148 19.0997 23.1918 18.7976C22.6688 18.4753 22.1272 18.1732 21.5668 17.8912C21.0251 17.6093 20.4928 17.2769 19.9698 16.8943C19.4468 16.4914 18.9799 16.0786 18.569 15.6556C18.1767 15.2125 17.8499 14.6687 17.5884 14.0242C17.3455 13.3797 17.2241 12.6647 17.2241 11.8792C17.2241 10.2477 17.6351 8.88822 18.4569 7.8006C19.2974 6.69285 20.4461 5.96777 21.903 5.62538C22.0338 5.58509 22.0991 5.49446 22.0991 5.35347V3.51057C22.0991 3.08761 22.2392 2.73515 22.5194 2.45317C22.7996 2.15106 23.1358 2 23.528 2C23.9203 2 24.2471 2.15106 24.5086 2.45317C24.7888 2.73515 24.9289 3.08761 24.9289 3.51057V5.29305C24.9289 5.43404 25.0036 5.52467 25.153 5.56495C26.3671 5.7865 27.4878 6.32024 28.5151 7.16616Z",
    fill: "url(#paint3_linear_1640_38215)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57626 36.5021C4.29067 36.5021 4.86981 35.9113 4.86981 35.1827C4.86981 34.454 4.29067 33.8633 3.57626 33.8633C2.86186 33.8633 2.28271 34.454 2.28271 35.1827C2.28271 35.9113 2.86186 36.5021 3.57626 36.5021Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1640_38215",
    x: 15,
    y: 0,
    width: 17,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1375 0 0 0 0 0.172 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38215",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1640_38215",
    x: 13,
    y: -2,
    width: 21,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1640_38215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38215",
    x1: 30,
    y1: 23.5217,
    x2: 17.5965,
    y2: 6.60467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2638DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1254FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38215",
    x1: -0.0000621217,
    y1: 35.9998,
    x2: 41.9999,
    y2: 35.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38215",
    x1: -0.0000621217,
    y1: 35.9998,
    x2: 41.9999,
    y2: 35.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38215",
    x1: 30,
    y1: 23.5217,
    x2: 13.6842,
    y2: 3.35759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0036C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWithdraw);
export default __webpack_public_path__ + "static/media/menu-withdraw.775851b2a074a1e4b0bbc54d48569adf.svg";
export { ForwardRef as ReactComponent };